import * as React from 'react';

import BubbleGroupInterface from './interface';
import DefaultChatBubble from '../ChatBubble';
import Message from '../../../Base/Message';
import moment from 'moment'
import styled from 'styled-components'
import {Avatar, Box as Section} from "reakit";
import {Box, Flex, Heading, Text} from 'rebass'
import styles from './styles';

const SideWrapper = styled(Box)`
  min-width: 10px;
`
export default class BubbleGroup extends React.Component {
  props;

  constructor(props: BubbleGroupInterface) {
    super(props);
  }

  /**
   * Parses and collects messages of one type to be grouped together.
   * @return {messageNodes} - a JSX wrapped group of messages
   */
  renderGroup(messages: [Message], id: number) {
    const {
      bubblesCentered,
      bubbleStyles,
      showSenderName,
      chatBubble,
      senderName,
    } = this.props;
    const ChatBubble = chatBubble || DefaultChatBubble;
    const sampleMessage = messages[0];

    const messageNodes = messages.map((message, i) => {
      return (
        <div>
          <ChatBubble
            key={i}
            message={message}
            bubblesCentered={bubblesCentered}
            bubbleStyles={bubbleStyles}
          />
          <div>
            {i != messages.length - 1 && moment.unix(messages[i].postTime).calendar() == moment.unix(messages[i+1].postTime).calendar() ? null : 
              <Flex flexWrap={'wrap'} flexDirection={'row'}>
                <Box ml={sampleMessage.id !== 0 ? 0: 'auto'}/>
                <Text p={2} fontSize={'11px'} color={'meta'}>{moment.unix(messages[i].postTime).calendar()}</Text>
              </Flex>
            }  
          </div>
        </div>
      );
    });

    return (
        // @ts-ignore
        sampleMessage.id !== 0 ?
              <Flex flexDirection={'row'} width={1} flexWrap={'wrap'}>
                {showSenderName &&
                ((senderName || sampleMessage.senderName) !== '' &&
                    (sampleMessage.id !== 0 && (
                        // @ts-ignore
                        <Box pt={'30px'} px={1} ><Avatar src={sampleMessage.profile_pic} width={'25px'} height={'25px'}/></Box>
                    )))}
                <Section {...styles.chatbubbleWrapper}>

                  {showSenderName &&
                  ((senderName || sampleMessage.senderName) !== '' &&
                      (sampleMessage.id !== 0 && (
                          // @ts-ignore
                          <Heading pl={2} style={styles.bubbleGroupHeader}>
                            {senderName || sampleMessage.senderName}
                          </Heading>
                      )))}
                  {messageNodes} 
                </Section>
              </Flex> :

              <Section {...styles.senderBubbleWrapper}>

                {showSenderName &&
                ((senderName || sampleMessage.senderName) !== '' &&
                    (sampleMessage.id !== 0 && (
                        // @ts-ignore
                        <Heading pl={2} style={styles.bubbleGroupHeader}>
                          {senderName || sampleMessage.senderName}
                        </Heading>
                    )))}
                {messageNodes}
              </Section>



    );
  }

  render() {
    const { messages, id } = this.props;
    return this.renderGroup(messages, id);
  }
}
